import {Dropdown, IDropdownOption} from '@fluentui/react';
import React from "react";

const requiredOptions: IDropdownOption[] = [
    { key: true, text: 'Yes' },
    { key: false, text: 'No' }
];

const optionalOptions: IDropdownOption[] = [
    { key: null, text: '' },
    { key: true, text: 'Yes' },
    { key: false, text: 'No' }
];

const BooleanDropdown = ({defaultValue, onUpdate, disabled, isreadonly, required }) => {

    const onChange = (key) => {
        const value = required ? key : { value: key }
        onUpdate(value)
    }

    return (
        <div>
            <div>
                <Dropdown
                    onChange={(e, v) => onChange(v.key)}
                    disabled={disabled || isreadonly}
                    defaultSelectedKey={defaultValue}
                    options={required ? requiredOptions : optionalOptions}
                />
            </div>
        </div>
    );
}

export default BooleanDropdown


// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/BooleanDropdown.js